export const runQuizAttemptCompletionCallbacks = async (quizResult, onAttemptComplete, onEnd) => {
    if (!quizResult.isCompleted)
        return;
    try {
        await onAttemptComplete?.();
    }
    catch (error) {
        // Alert tracking must never block the existing pass-only completion path.
        console.error('Quiz attempt completion callback failed', error);
    }
    if (quizResult.isPassed)
        await onEnd?.();
};
//# sourceMappingURL=quizAttemptCompletion.js.map